export function sortByNumericField(array: Array<any>, field: string, order: string = 'asc') {
    if (order === 'asc')
        return array.sort((prev: any, next: any) => prev[field] - next[field])
    else if (order === 'desc')
        return array.sort((prev: any, next: any) => next[field] - prev[field])
}
